import React, { forwardRef } from 'react';
import { joinClasses } from '../../../Utils/className.util';
import styles from './ScrollContainer.module.scss';

interface ScrollContainerProps {
	children: React.ReactNode | React.ReactNode[];
	wrapperId?: string;
	className?: string;
}

const ScrollContainer = forwardRef<HTMLDivElement, ScrollContainerProps>(
	({ children, wrapperId, className }, ref) => (
		<div
			ref={ref}
			className={joinClasses([styles.wrapper, className])}
			id={wrapperId}>
			{children}
		</div>
	),
);

ScrollContainer.displayName = 'ScrollContainer';

export default ScrollContainer;
